//==========import components===============
import TitleSection from 'components/common/TitleSection';

const TakeCare = ({ bgColor }) => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE TAKE CARE',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section
      className={`takeCareSec DBlock py-10 sm:py-12 px-6 sm:px-10 ${
        bgColor ? 'bg-eventLightPink' : 'bg-white'
      }`}>
      <div className='max-w-7xl mx-auto'>
        <div className='DBlock'>
          <TitleSection titleDetail={titleDetail} />
        </div>
        <div className='DBlock'>
          <div className='max-w-6xl mx-auto  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative'>
            <div className='lg:col-span-2'>
              <h3 className='uppercase text-eventGray text-sm lg:text-lg '>
                WE HAVE BEST SOLUTIONS FOR ALL
              </h3>
              <h1 className='uppercase text-black font-bold text-lg sm:text-2xl md:text-3xl  lg:text-4xl'>
                Bantu Saudara yang Terdampak.
              </h1>
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 pt-5'>
                <div>
                  <h2 className='font-bold text-sm text-eventLightYellow pr-1 sm:inline-block block'>
                    WE CARE
                  </h2>
                  <p className='text-eventGray font-normal text-sm'>
                    WE CARE! We know the stress one has for hosting an event and
                    at Mahara we care to keep your events stress-free!
                  </p>
                  <h2 className='font-bold text-sm text-eventLightYellow pr-1 pt-5 sm:inline-block block'>
                    MEMORIES SOLDIFIED!
                  </h2>
                  <p className='text-eventGray font-normal text-sm'>
                    We promise to help you make delightful and happy memories
                    through Mahara’s beautiful events.
                  </p>
                </div>
                <div>
                  <h2 className='font-bold text-sm text-eventLightYellow pr-1 sm:inline-block block'>
                    EXCEPTIONAL DELIVERY!
                  </h2>
                  <p className='text-eventGray font-normal text-sm'>
                    We know the stress one has for hosting an event and at
                    Mahara we care to keep your events stress-free!
                  </p>
                  <h2 className='font-bold text-sm text-eventLightYellow pt-5  pr-1 sm:inline-block block'>
                    EXPERTISE GUARANTEED!
                  </h2>
                  <p className='text-eventGray font-normal text-sm'>
                    We at Mahara work with “Maharat” to make all your dreamy
                    events come to life.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <img
                src='/assets/images/what-we-do/takeCare.png'
                alt='eventImg'
                className='w-full'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TakeCare;
